module.exports = __webpack_public_path__ + "static/img/01.6c798ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/05/01.jpg
// module id = kp9y
// module chunks = 0